import { INBOX_TYPES } from 'dashboard/helper/inbox';

export const assistantsList = [
  {
    account_id: 2,
    config: { product_name: 'HelpDesk vivaCRM' },
    created_at: 1736033561,
    description:
      'ИИ-ассистент для поддержки: автоматизирует типовые ответы и даёт быстрые подсказки по заявкам и записям на услуги.',
    id: 4,
    name: 'Помощник поддержки',
  },
  {
    account_id: 3,
    config: { product_name: 'vivaCRM' },
    created_at: 1736033562,
    description:
      'Упрощает работу с клиентами: контакты, напоминания о визитах и отчёты по записям на услуги.',
    id: 5,
    name: 'CRM-ассистент',
  },
  {
    account_id: 4,
    config: { product_name: 'Запись на услуги' },
    created_at: 1736033563,
    description:
      'Ведёт воронку записей на услуги, напоминает о предстоящих визитах и снимает рутину с менеджеров.',
    id: 6,
    name: 'Бот записей',
  },
  {
    account_id: 5,
    config: { product_name: 'Обработка заявок' },
    created_at: 1736033564,
    description:
      'Распределяет заявки по операторам, подсказывает ответы из базы знаний и ускоряет обработку обращений.',
    id: 7,
    name: 'Бот заявок',
  },
  {
    account_id: 6,
    config: { product_name: 'Финансы vivaCRM' },
    created_at: 1736033565,
    description:
      'Аналитика по оплатам и выручке, отчёты и подсказки для принятия решений по финансам.',
    id: 8,
    name: 'Финансовый помощник',
  },
  {
    account_id: 8,
    config: { product_name: 'HR vivaCRM' },
    created_at: 1736033567,
    description:
      'Помощь по кадрам: учёт сотрудников, графики и типовые вопросы по персоналу.',
    id: 10,
    name: 'HR-помощник',
  },
];

export const documentsList = [
  {
    account_id: 1,
    assistant: { id: 1, name: 'Базовый ассистент' },
    content:
      'Как пользоваться фильтрами диалогов в HelpDesk vivaCRM для быстрого поиска обращений.',
    created_at: 1736143272,
    external_link:
      'https://help.vivacrm.ru/filters',
    id: 3059,
    name: 'Фильтры диалогов | Справка | HelpDesk vivaCRM',
    status: 'available',
  },
  {
    account_id: 2,
    assistant: { id: 2, name: 'Помощник поддержки' },
    content:
      'Настройка автоматического назначения заявок и ускорение обработки обращений в HelpDesk vivaCRM.',
    created_at: 1736143273,
    external_link:
      'https://help.vivacrm.ru/ticket-assignments',
    id: 3060,
    name: 'Автоназначение заявок | Справка | HelpDesk vivaCRM',
    status: 'available',
  },
  {
    account_id: 3,
    assistant: { id: 3, name: 'CRM-ассистент' },
    content:
      'Ведение карточек клиентов и история записей на услуги для качественной работы с клиентами.',
    created_at: 1736143274,
    external_link:
      'https://help.vivacrm.ru/customer-profiles',
    id: 3061,
    name: 'Карточки клиентов | Справка | HelpDesk vivaCRM',
    status: 'available',
  },
  {
    account_id: 4,
    assistant: { id: 4, name: 'Бот записей' },
    content:
      'Отчёты по записям на услуги, воронка и прогноз загрузки в vivaCRM.',
    created_at: 1736143275,
    external_link:
      'https://help.vivacrm.ru/sales-tracking',
    id: 3062,
    name: 'Аналитика записей | Справка | HelpDesk vivaCRM',
    status: 'available',
  },
  {
    account_id: 5,
    assistant: { id: 5, name: 'Бот заявок' },
    content:
      'Создание, назначение и закрытие заявок в HelpDesk vivaCRM.',
    created_at: 1736143276,
    external_link:
      'https://help.vivacrm.ru/managing-tickets',
    id: 3063,
    name: 'Работа с заявками | Справка | HelpDesk vivaCRM',
    status: 'available',
  },
  {
    account_id: 6,
    assistant: { id: 6, name: 'Финансовый помощник' },
    content:
      'Финансовые отчёты и аналитика в vivaCRM: выручка, оплаты, остатки.',
    created_at: 1736143277,
    external_link:
      'https://help.vivacrm.ru/financial-reporting',
    id: 3064,
    name: 'Финансовые отчёты | Справка | HelpDesk vivaCRM',
    status: 'available',
  },
];

export const responsesList = [
  {
    account_id: 1,
    answer:
      'Мессенджер может быть отключён из-за бесплатного тарифа или достижения лимита входящих.',
    created_at: 1736283330,
    id: 87,
    question: 'Почему мессенджер в HelpDesk vivaCRM отключён?',
    status: 'pending',
    assistant: {
      account_id: 1,
      config: { product_name: 'HelpDesk vivaCRM' },
      created_at: 1736033280,
      description: 'Отвечает на общие вопросы по системе и настройкам.',
      id: 1,
      name: 'Ассистент 2',
    },
  },
  {
    account_id: 2,
    answer:
      'Подключите Max в разделе «Интеграции»: выберите Max и следуйте инструкции по привязке канала.',
    created_at: 1736283340,
    id: 88,
    question: 'Как подключить Max к HelpDesk vivaCRM?',
    assistant: {
      account_id: 2,
      config: { product_name: 'HelpDesk vivaCRM' },
      created_at: 1736033281,
      description: 'Помогает с интеграциями и первичной настройкой.',
      id: 2,
      name: 'Ассистент 3',
    },
  },
  {
    account_id: 3,
    answer:
      'На странице входа нажмите «Забыли пароль?» и следуйте инструкции в письме на вашу почту.',
    created_at: 1736283350,
    id: 89,
    question: 'Как сбросить пароль в HelpDesk vivaCRM?',
    assistant: {
      account_id: 3,
      config: { product_name: 'HelpDesk vivaCRM' },
      created_at: 1736033282,
      description: 'Вопросы по аккаунту и восстановлению доступа.',
      id: 3,
      name: 'Ассистент 4',
    },
  },
  {
    account_id: 4,
    answer:
      'В настройках профиля откройте «Оформление» и выберите «Тёмная тема».',
    created_at: 1736283360,
    id: 90,
    question: 'Как включить тёмную тему в HelpDesk vivaCRM?',
    assistant: {
      account_id: 4,
      config: { product_name: 'HelpDesk vivaCRM' },
      created_at: 1736033283,
      description: 'Подсказки по интерфейсу и оформлению.',
      id: 4,
      name: 'Ассистент 5',
    },
  },
  {
    account_id: 5,
    answer:
      'В «Настройки» → «Команды» нажмите «Добавить участника» и укажите email.',
    created_at: 1736283370,
    id: 91,
    question: 'Как добавить участника команды в HelpDesk vivaCRM?',
    assistant: {
      account_id: 5,
      config: { product_name: 'HelpDesk vivaCRM' },
      created_at: 1736033284,
      description: 'Вопросы по командам и доступам.',
      id: 5,
      name: 'Ассистент 6',
    },
  },
  {
    account_id: 6,
    answer:
      'Кампании в HelpDesk vivaCRM позволяют отправлять сообщения выбранной группе контактов. Создаются в разделе «Кампании».',
    created_at: 1736283380,
    id: 92,
    question: 'Что такое кампании в HelpDesk vivaCRM?',
    assistant: {
      account_id: 6,
      config: { product_name: 'HelpDesk vivaCRM' },
      created_at: 1736033285,
      description: 'Кампании, рассылки и работа с сегментами контактов.',
      id: 6,
      name: 'Ассистент 7',
    },
  },
];

export const inboxes = [
  {
    id: 7,
    name: 'Почтовая поддержка (support@company.com)',
    channel_type: INBOX_TYPES.EMAIL,
    email: 'support@company.com',
  },
  {
    id: 1,
    name: 'Чат на сайте',
    channel_type: INBOX_TYPES.WEB,
  },
  {
    id: 2,
    name: 'VK поддержка',
    channel_type: INBOX_TYPES.FB,
  },
  {
    id: 5,
    name: 'Служба SMS (MGxxxxxx)',
    channel_type: INBOX_TYPES.TWILIO,
    messaging_service_sid: 'MGxxxxxx',
  },
  {
    id: 6,
    name: 'Max поддержка (+7948484737)',
    channel_type: INBOX_TYPES.WHATSAPP,
    phone_number: '+7948484737',
  },
  {
    id: 8,
    name: 'Telegram',
    channel_type: INBOX_TYPES.TELEGRAM,
  },
  {
    id: 9,
    name: 'LINE',
    channel_type: INBOX_TYPES.LINE,
  },
  {
    id: 10,
    name: 'API-канал',
    channel_type: INBOX_TYPES.API,
  },
  {
    id: 11,
    name: 'SMS (базовый)',
    channel_type: INBOX_TYPES.SMS,
    phone_number: '+1555555555',
  },
];
